import React from "react";
import TextField from "@mui/material/TextField";

const MoneyTextField = ({
  id,
  label,
  value,
  setValue,
  prefix = "R$",
  required = false,
  error = false,
  helperText = "",
  marginBottom = 0,
  fullWidth = false,
}) => {
  // Format value for display - handles any input format
  const formatValueForDisplay = (val) => {
    // Handle null/undefined
    if (val === null || val === undefined) return "";

    // Convert number to string with comma decimal
    if (typeof val === "number") {
      return val.toFixed(2).replace(".", ",");
    }

    // If string already has comma, return as is
    if (typeof val === "string" && val.includes(",")) {
      return val;
    }

    // If string has dot (like from API '5.00'), replace with comma
    if (typeof val === "string" && val.includes(".")) {
      return val.replace(".", ",");
    }

    // Simple string without decimals
    if (typeof val === "string") {
      return `${val},00`;
    }

    return "";
  };

  // Format user input
  const formatMoney = (inputValue) => {
    // Remove all non-digit characters
    const digits = inputValue.replace(/\D/g, "");

    // Format to ensure two decimal places
    let formattedValue = "";
    if (digits.length === 0) {
      formattedValue = "0,00";
    } else if (digits.length === 1) {
      formattedValue = `0,0${digits}`;
    } else if (digits.length === 2) {
      formattedValue = `0,${digits}`;
    } else {
      const integerPart = digits.slice(0, digits.length - 2);
      const decimalPart = digits.slice(-2);
      // Add comma separator for decimals
      formattedValue = `${parseInt(
        integerPart || "0",
        10
      ).toLocaleString()}${","}${decimalPart}`;
    }

    return formattedValue;
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    // Remove prefix and format
    const valueWithoutPrefix = inputValue
      .replace(new RegExp(`^${prefix}\\s*`), "")
      .trim();
    const formattedValue = formatMoney(valueWithoutPrefix);
    setValue(formattedValue);
  };

  const displayValue = value ? `${prefix} ${formatValueForDisplay(value)}` : "";

  return (
    <TextField
      id={id}
      label={label}
      value={displayValue}
      onChange={handleChange}
      fullWidth={fullWidth}
      error={error}
      helperText={helperText}
      variant="outlined"
      inputProps={{ inputMode: "numeric" }}
      sx={{ marginBottom: marginBottom }}
    />
  );
};

export default MoneyTextField;
